import React from 'react';
import SponsorItem from './SponsorItem.jsx';
import TablePagination from 'components/Pagination/TablePagination';
import Headers from './Headers.jsx';

function SponsorList({
  sponsors,
  navigateToSponsor,
  checkedSponsorIds,
  sponsor_ids,
  paginationProps,
  onOrderChange,
  query
}) {
  return (
    <table>
      <Headers
        onChange={onOrderChange}
        value={query.order}
      />
      {sponsors.map(sponsor => (
        <SponsorItem
          sponsor={sponsor}
          key={sponsor.id}
          navigateToSponsor={navigateToSponsor}
          checkedSponsorIds={checkedSponsorIds}
          sponsor_ids={sponsor_ids}
        />
      ))}
      <tr>
        <td colSpan="12">
          <TablePagination
            {...paginationProps}
          />
        </td>
      </tr>
    </table>
  );
}

SponsorList.defaultProps = {};

SponsorList.propTypes = {};

export default SponsorList;



// WEBPACK FOOTER //
// ./src/components/Admin/Sponsor/List/index.jsx